const pl = {
    lengthMenu: 'Pokaż _MENU_ wpisów',
    zeroRecords: 'Nie znaleziono pasujących wpisów',
    infoEmpty: 'Brak wpisów do wyświetlenia',
    search: '',
    emptyTable: 'Brak danych w tabeli',
    infoThousands: ' ',
    loadingRecords: 'Ładowanie...',
    paginate: {
        first: 'Pierwsza',
        last: 'Ostatnia',
        next: 'Następna',
        previous: 'Poprzednia',
    },
    aria: {
        sortAscending: ': aktywuj, by posortować kolumnę rosnąco',
        sortDescending: ': aktywuj, by posortować kolumnę malejąco',
    },
    autoFill: {
        fill: 'Wypełnij wszystkie komórki <i>%d</i>',
        fillHorizontal: 'Wypełnij komórki poziomo',
        fillVertical: 'Wypełnij komórki pionowo',
        cancel: 'Anuluj',
        info: 'Informacja',
    },
    buttons: {
        colvis: 'Widoczność kolumn',
        colvisRestore: 'Przywróć widoczność',
        copy: 'Kopiuj',
        copySuccess: {
            1: 'Skopiowano 1 wiersz do schowka',
            _: 'Skopiowano %d wierszy do schowka',
        },
        copyTitle: 'Skopiuj do schowka',
        csv: 'CSV',
        excel: 'Excel',
        pageLength: {
            '-1': 'Pokaż wszystkie wiersze',
            _: 'Pokaż %d wierszy',
            1: 'Pokaż 1 wiersz',
        },
        pdf: 'PDF',
        print: 'Drukuj',
        copyKeys:
            'Naciśnij ctrl lub u2318 + C, aby skopiować dane tabeli do schowka. Aby anulować, kliknij tutaj lub naciśnij escape.',
        collection: 'Kolekcja',
    },
    processing: 'Przetwarzanie...',
    decimal: ',',
    searchBuilder: {
        add: 'Dodaj',
        clearAll: 'Wyczyść wszystko',
        condition: 'Warunek',
        data: 'Dane',
        deleteTitle: 'Usuń',
        value: 'Wartość',
        conditions: {
            date: {
                after: 'Po',
                before: 'Przed',
                between: 'Pomiędzy',
                empty: 'Puste',
                equals: 'Równe',
                not: 'Nie',
                notBetween: 'Nie jest pomiędzy',
                notEmpty: 'Nie jest puste',
            },
            number: {
                between: 'Pomiędzy',
                empty: 'Puste',
                equals: 'Równe',
                gt: 'Większe niż',
                gte: 'Większe lub równe',
                lt: 'Mniejsze niż',
                lte: 'Mniejsze lub równe',
                not: 'Nie',
                notBetween: 'Nie jest pomiędzy',
                notEmpty: 'Nie jest puste',
            },
            string: {
                contains: 'Zawiera',
                empty: 'Puste',
                endsWith: 'Kończy się na',
                equals: 'Równe',
                not: 'Nie',
                notEmpty: 'Nie jest puste',
                startsWith: 'Zaczyna się od',
            },
            array: {
                equals: 'Równe',
                empty: 'Puste',
                contains: 'Zawiera',
                not: 'Nie',
                notEmpty: 'Nie jest puste',
                without: 'Bez',
            },
        },
        logicAnd: 'I',
        logicOr: 'Lub',
        button: {
            0: 'Kreator wyszukiwania',
            _: 'Kreator wyszukiwania (%d)',
        },
        leftTitle: 'Zmniejsz wcięcie',
        rightTitle: 'Zwiększ wcięcie',
        title: {
            0: 'Kreator wyszukiwania',
            _: 'Kreator wyszukiwania (%d)',
        },
    },
    searchPanes: {
        clearMessage: 'Wyczyść wszystko',
        collapse: {
            0: 'Panele wyszukiwania',
            _: 'Panele wyszukiwania (%d)',
        },
        count: '{total}',
        countFiltered: '{shown} ({total})',
        emptyPanes: 'Brak paneli wyszukiwania',
        loadMessage: 'Ładowanie paneli wyszukiwania...',
        title: 'Aktywne filtry: %d',
    },
    select: {
        1: 'Wybrano %d wiersz',
        _: 'Wybrano %d wierszy',
        cells: {
            1: 'Wybrano 1 komórkę',
            _: 'Wybrano %d komórek',
        },
        columns: {
            1: 'Wybrano 1 kolumnę',
            _: 'Wybrano %d kolumn',
        },
        rows: {
            0: 'Nie wybrano żadnego wiersza',
            1: 'Wybrano 1 wiersz',
            _: 'Wybrano %d wierszy',
        },
        0: 'Nie wybrano wierszy',
        2: 'Wybrano %d wiersze',
    },
    thousands: ' ',
    searchPlaceholder: 'Szukaj...',
    info: 'Pozycje od _START_ do _END_ z _TOTAL_ łącznie',
    infoFiltered: '(filtrowanie spośród _MAX_ wszystkich wpisów)',
    datetime: {
        previous: 'Poprzedni',
        next: 'Następny',
        hours: 'Godziny',
        minutes: 'Minuty',
        seconds: 'Sekundy',
        unknown: 'Nieznane',
        amPm: ['am', 'pm'],
    },
    editor: {
        close: 'Zamknij',
        create: {
            button: 'Nowy',
            title: 'Dodaj nowy wpis',
            submit: 'Dodaj',
        },
        edit: {
            button: 'Edytuj',
            title: 'Edytuj wpis',
            submit: 'Aktualizuj',
        },
        remove: {
            button: 'Usuń',
            title: 'Usuń',
            submit: 'Usuń',
            confirm: {
                _: 'Czy na pewno chcesz usunąć %d wierszy?',
                1: 'Czy na pewno chcesz usunąć 1 wiersz?',
            },
        },
        error: {
            system: 'Wystąpił błąd systemowy',
        },
        multi: {
            title: 'Wiele wartości',
            info: 'Wybrane elementy zawierają różne wartości dla tego pola. Aby edytować i ustawić wszystkie elementy na tę samą wartość, kliknij tutaj, w przeciwnym razie zachowają one swoje indywidualne wartości.',
            restore: 'Cofnij zmiany',
            noMulti: 'To pole może być edytowane indywidualnie, ale nie jako część grupy.',
        },
    },
};

export default pl;
